export const blockIconsFileDriveFileMove = (
	<span className='material-symbols-outlined'>drive_file_move</span>
);
